import React, { Component } from 'react'



export default class Badge extends Component {

    render() {
        return (
            <div className="badge">
                {this.props.children}
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/Badge.js